"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var tslib_1 = require("tslib");
var I18n = require("i18n-js");
var React = require("react");
var lowlight_1 = require("./lowlight");
var sanitized_render_1 = require("@reverbdotcom/commons/dist/components/sanitized_render");
var bind_1 = require("../../../bind");
var classNames = require('classnames');
var SiteSearchSuggestion = /** @class */ (function (_super) {
    tslib_1.__extends(SiteSearchSuggestion, _super);
    function SiteSearchSuggestion() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        _this.displayName = 'SiteSearchSuggestion';
        return _this;
    }
    SiteSearchSuggestion.prototype.submitSelection = function (e) {
        e.preventDefault();
        this.props.selectSuggestion(this.props.suggestion);
    };
    SiteSearchSuggestion.prototype.renderContext = function () {
        if (!this.props.suggestion.context) {
            return null;
        }
        return (React.createElement("small", null,
            I18n.t('discovery.searchBar.in'),
            " ",
            this.props.suggestion.context));
    };
    SiteSearchSuggestion.prototype.renderValue = function () {
        return lowlight_1.default({
            input: this.props.lastTypedValue,
            output: this.props.suggestion.value,
            emphasize: function (_, em) { return em.pre + "<b>" + em.word + "</b>" + em.post; },
            noop: function (_, em) { return em.word; },
        }).join(' ');
    };
    SiteSearchSuggestion.prototype.render = function () {
        var classes = classNames('site-search__dropdown__section__item', { 'site-search__dropdown__section__item--selected': this.props.active });
        return (React.createElement("div", { className: classes },
            React.createElement("a", { onClick: this.submitSelection },
                React.createElement(sanitized_render_1.default, { html: this.renderValue() }),
                this.renderContext())));
    };
    SiteSearchSuggestion.defaultProps = {
        lastTypedValue: '',
    };
    tslib_1.__decorate([
        bind_1.default
    ], SiteSearchSuggestion.prototype, "submitSelection", null);
    return SiteSearchSuggestion;
}(React.Component));
exports.default = SiteSearchSuggestion;
//# sourceMappingURL=site_search_suggestion.js.map


//////////////////
// WEBPACK FOOTER
// /home/reverb/workspace/core.deploy.production/build/src/node_modules/@reverbdotcom/discovery-ui/dist/components/discovery/site_search/site_search_suggestion.js
// module id = 4uOV
// module chunks = 20 21